import React, { useMemo } from "react";
import CardAnimation from "../CardAnimation";
import Card from "../../dashboard/card/Card";
import TaggedList from "../../dashboard/shared/taggedList/TaggedList";
import { DynamicDataCardList } from "../../../features/hospital/components";
import { PAGE_TYPE } from "../notes/NotesList";
import { OVERALL_PAGE_SUB_TYPE } from "../../../types/pages.type";
import { CUSTOM_TAB_TYPE } from "../../../types/common.type";
import { QUESTION_INPUT_TYPE } from "../../../types/question.type";
import _ from "lodash";
// import { QUESTION_INPUT_TYPE } from "../../../types/question.type";

const DynamicCardItem = ({
  ele = {},
  pageType = '',
  isCustomTab = false,
  selectedCards = [],
  loading = false,
  loadingComparison = false,
  filterListData = {},
  filterListDataComparison = {},
  cardFilter = {},
  handleChartDialog = () => { },
  handleOnClickReport = () => { },
  handleToggle = () => { },
  handleToggleAll = () => { },
  filter = {},
  filterComparison = {},
  dbData = {},
  dbDataComparison = {},
  percentageAgainst = 0,
  projectionDays = 0,
  getPriorityNumber = () => 0,
  transferType = '',
  lockedTotalBy = '',
  filterTotal = 0,
  disableInteractions = false,
  admissionCompareAgainst = null,
  admissionCompareAgainstComparison = null,
  reverseColorsAdmissionPage = false,
  averageCensusComparison = null,
  headerActions = null,
  sharedUsersByTabId = {},
  sharedWithEveryoneByTabId = {}
}) => {
  const { accessor, isCustomTab: eleIsCustomTab, dashboardType, type, label, title, tableLabel, description, question, _id, customQuestionInputType } = ele;

  const cardSelectedItems = cardFilter?.[accessor] ?? [];
  const cardID = filterListData?.[accessor]?.[0]?.id;
  const isSelectedTotalCard = cardSelectedItems.indexOf(cardID) !== -1;

  const isAnotherDashboard = eleIsCustomTab && !dashboardType?.includes(pageType);

  const handleCardClick = async (titleParam = null, uniqueKey = null) => {
    if (disableInteractions) return;
    // For duplicate titles (multiple same dashboard), use composite key format: accessor__uniqueKey
    // This allows multiple selections of the same dashboard
    const compositeKey = uniqueKey && accessor ? `${accessor}__${uniqueKey}` : null;
    // Get comparison item for comparison filters
    const comparisonItem = filterListDataComparison?.[accessor]?.[0];
    await handleToggle({
      item: filterListData?.[accessor]?.[0],
      itemComparison: comparisonItem, // Pass comparison item directly
      type: accessor,
      isChecked: isSelectedTotalCard,
      cardTitle: title || label || tableLabel,
      question: {
        isCustom: true,
        customQuestionInputType: question?.customQuestionInputType,
        isCustomTab: false,
        cardTitle: title || label || tableLabel,
        customTab: type,
        accessor: accessor, // Pass accessor so handleToggle can find comparison item
        compositeKey: compositeKey, // Pass composite key for multiple selections
        uniqueKey: uniqueKey // Also pass uniqueKey for reference
      },
      isCustomTab: false,
    });
  };

  const handleCardAction = (title, defaultTab) =>
    handleChartDialog(title, accessor, null, false, defaultTab, {
      isCustom: true,
      customQuestionInputType,
      isCustomTab,
      isAnotherDashboard,
      customTab: ele,
      level: filterListData?.[accessor]?.[0]?.level,
      cardTitle: title || label || tableLabel,
      ...(isCustomTab && { dashboardType }),
    });

  const handleReportClick = (title, otherData) => {
    const reportProps = {
      questionId: _id,
      isCustomCard: true,
      isCustomTab,
      cardTitle: title || label || tableLabel,
      question: ele,
    };
    if (pageType === 'admission') {
      handleOnClickReport(accessor, title, false, false, otherData, reportProps);
    } else {
      handleOnClickReport(accessor, title, false, otherData, reportProps);
    }
  };

  const isDisabled = useMemo(() => {

    if (pageType !== PAGE_TYPE.OVERALL || ele?.page !== PAGE_TYPE.OVERALL) return false;
    if (transferType === OVERALL_PAGE_SUB_TYPE.TOTAL) {
      return ele?.type === CUSTOM_TAB_TYPE.combineTab;
    }
    if (ele?.filters?.length > 0) {
      const filterDashboardsArr = _.uniq(ele?.filters?.map((filter) => filter?.dashboard));

      const outGoingDashboard = [PAGE_TYPE.HOSPITAL, PAGE_TYPE.COMMUNITY_TRANSFER, PAGE_TYPE.DECEASED, 'overallOutgoing'];
      const inComingDashboard = [PAGE_TYPE.ADMISSION, 'overallIncoming'];
      if (
        transferType === OVERALL_PAGE_SUB_TYPE.TOTAL_OUTGOING &&
        filterDashboardsArr.some(dashboard => inComingDashboard.includes(dashboard))
      ) {
        return true;
      }
      if (
        transferType === OVERALL_PAGE_SUB_TYPE.TOTAL_INCOMING &&
        filterDashboardsArr.some(dashboard => outGoingDashboard.includes(dashboard))
      ) {
        return true;
      }
    }
    // if (transferType === OVERALL_PAGE_SUB_TYPE.TOTAL) {
    //   return true;
    // }
    // if (filterPageType === CUSTOM_TAB_PAGE_TYPE.OVERALL_INCOMING && transferType === OVERALL_PAGE_SUB_TYPE.TOTAL_OUTGOING) {
    //   return true;
    // }
    // if (filterPageType === CUSTOM_TAB_PAGE_TYPE.OVERALL_OUTGOING && transferType === OVERALL_PAGE_SUB_TYPE.TOTAL_INCOMING) {
    //   return true;
    // }
    return false;
  }, [ele?.filters, ele?.page, ele?.type, pageType, transferType]);

  const selectAllOption = useMemo(() => {
    return customQuestionInputType === QUESTION_INPUT_TYPE.UNLIMITED_ANSWERS;
  }, [customQuestionInputType]);

  return (
    <CardAnimation
      id={`${accessor}_scroll`}
      //checked={_.includes(selectedCards, accessor)}
      checked={true}
      style={{ height: '100%' }}
    >
      {/* <Grid item xs={12} sm={6} md={6} lg={4}> for drag functionality make disabled */}
      <Card
        isDisabled={isDisabled}
        disableInteractions={disableInteractions}
        customCardData={ele}
        sharedUsers={sharedUsersByTabId?.[String(_id)] || []}
        isSharedWithEveryoneFallback={Boolean(sharedWithEveryoneByTabId?.[String(_id)])}
        tooltipContent={description}
        key={accessor}
        pageType={pageType}
        loading={loading || loadingComparison}
        title={title || label || tableLabel}
        priorityNumber={getPriorityNumber(accessor)}
        handleOnClickAction={handleCardAction}
        taggedList={
          <TaggedList
            type={accessor}
            data={filterListData?.[accessor] ?? []}
            selectedItem={cardFilter?.[accessor] ?? []}
          />
        }
        filterMenuData={{
          type: accessor,
          data: filterListData?.[accessor] ?? [],
          selectedItem: cardFilter?.[accessor] ?? [],
        }}
        handleOnClickReport={handleReportClick}
        selectAllOption={selectAllOption}
        selectedItems={cardFilter?.[accessor] ?? []}
        data={filterListData?.[accessor] ?? []}
        type={accessor}
        handleToggleAll={handleToggleAll}
        canBeSearched
        cardType={accessor}
        style={{ height: '100%' }}
        headerActions={headerActions}
      >
        <DynamicDataCardList
          disableInteractions={disableInteractions}
          totalTransfers={dbData.total}
          totalTransfersComparison={dbDataComparison?.total}
          filterListData={filterListData}
          filterListDataComparison={filterListDataComparison}
          question={ele}
          cardTitle={title || label || tableLabel}
          data={filterListData?.[accessor] ?? []}
          dataComparison={filterListDataComparison?.[accessor] ?? []}
          handleToggle={handleToggle}
          handleToggleAll={handleToggleAll}
          selectedItem={cardFilter?.[accessor]}
          spacialSelectedItem={cardFilter?.[`${accessor}_spacial`]}
          type={accessor}
          filter={filter}
          loading={loading || loadingComparison}
          filterComparison={filterComparison}
          page={pageType}
          averageCensus={percentageAgainst}
          projectionDays={projectionDays}
          isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
          priorityNumber={getPriorityNumber(accessor)}
          transferType={transferType}
          lockedTotalBy={lockedTotalBy}
          isCustomTab={isCustomTab}
          filterTotal={filterTotal}
          handleCardClick={handleCardClick}
          isSelectedTotalCard={isSelectedTotalCard}
          cardFilter={cardFilter}
          isDisabled={isDisabled}
          admissionCompareAgainst={admissionCompareAgainst}
          admissionCompareAgainstComparison={admissionCompareAgainstComparison}
          reverseColorsAdmissionPage={reverseColorsAdmissionPage}
          averageCensusComparison={averageCensusComparison}
        />
      </Card>
      {/* </Grid>for drag functionality make disabled */}
    </CardAnimation>
  );
};

export default DynamicCardItem;
